module.exports = __webpack_public_path__ + "img/img_3@2x.9f65d368.svg";